lang = {
    "dropzone": {
        "dictDefaultMessage": "Glisser les fichiers ici pour téléverser",
        "dictFallbackMessage": "Votre fureteur ne supporte pas le 'glisser/déposer'.",
        "dictFallbackText": "Veuillez utilsier le formulaire classique ci-bas pour téléverser vos fichiers.",
        "dictFileTooBig": "Votre fichier est trop lourd ({{filesize}}MiB). Taille maximale permise: {{maxFilesize}}MiB.",
        "dictInvalidFileType": "Ce type de fichier n'est pas accepté."
    }
};